"use strict";

var _slicedToArray = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/slicedToArray");

require("core-js/modules/es6.function.name");

var _objectWithoutProperties = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _defineProperty = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/defineProperty");

require("core-js/modules/es6.object.define-property");

var _variantIcon;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputSelect = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _utils = require("@creditas/utils");

var _CheckCircle = _interopRequireDefault(require("@creditas/icons/dist/notification/CheckCircle"));

var _AlertTriangle = _interopRequireDefault(require("@creditas/icons/dist/alert/AlertTriangle"));

var _XCircle = _interopRequireDefault(require("@creditas/icons/dist/action/XCircle"));

var _Loader = _interopRequireDefault(require("@creditas/icons/dist/file/Loader"));

var _ChevronUp = _interopRequireDefault(require("@creditas/icons/dist/navigation/ChevronUp"));

var _ChevronDown = _interopRequireDefault(require("@creditas/icons/dist/navigation/ChevronDown"));

var _components = require("./components");

var _FormControl = require("./FormControl");

var _InputSelectComponent = require("./InputSelectComponent");

var _InputLabel = require("./InputLabel");

var _HelperText = require("./HelperText");

var _InputIcon = require("./InputIcon");

var _core = require("@emotion/core");
/* eslint-disable max-lines-per-function */


var propTypes = process.env.NODE_ENV !== "production" ? {
  component: (0, _propTypes.oneOfType)([_propTypes.elementType, _propTypes.string]),
  className: _propTypes.string,
  'data-testid': _propTypes.string,
  withRef: (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.func]),
  id: _propTypes.string,
  name: _propTypes.string,
  onBlur: _propTypes.func,
  onChange: _propTypes.func,
  onFocus: _propTypes.func,
  onInput: _propTypes.func,
  label: _propTypes.string,
  width: _propTypes.string,
  value: _propTypes.string,
  defaultValue: _propTypes.string,
  size: _propTypes.string,
  type: _propTypes.string,
  disabled: _propTypes.bool,
  readOnly: _propTypes.bool,
  loading: _propTypes.bool,
  helperText: _propTypes.string,
  variant: _propTypes.string,
  inputBackground: _propTypes.string || _propTypes.func,
  hideDefaultOption: _propTypes.bool,
  options: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)(_propTypes.string), (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    value: _propTypes.string.isRequired,
    text: _propTypes.string.isRequired
  }).isRequired)]).isRequired
} : {};
var selectIconPropTypes = process.env.NODE_ENV !== "production" ? {
  inputFocus: _propTypes.bool,
  inputHover: _propTypes.bool,
  disabled: _propTypes.bool,
  readOnly: _propTypes.bool
} : {};

var IconSuccess = function IconSuccess() {
  return (0, _core.jsx)(_CheckCircle["default"], {
    color: _components.VARIANT_TYPES.success,
    fontSize: "small"
  });
};

var IconWarning = function IconWarning() {
  return (0, _core.jsx)(_XCircle["default"], {
    color: _components.VARIANT_TYPES.warning,
    fontSize: "small"
  });
};

var IconError = function IconError() {
  return (0, _core.jsx)(_AlertTriangle["default"], {
    color: _components.VARIANT_TYPES.danger,
    fontSize: "small"
  });
};

var IconLoading = function IconLoading() {
  return (0, _core.jsx)(_Loader["default"], {
    color: "neutral05",
    fontSize: "small"
  });
};

var SelectIcon = function SelectIcon(_ref) {
  var inputFocus = _ref.inputFocus,
      inputHover = _ref.inputHover,
      disabled = _ref.disabled,
      readOnly = _ref.readOnly;

  if (disabled || readOnly) {
    return (0, _core.jsx)(_ChevronDown["default"], {
      fontSize: "small"
    });
  }

  if (inputHover && !inputFocus) {
    return (0, _core.jsx)(_ChevronDown["default"], {
      color: "neutral07",
      fontSize: "small"
    });
  }

  return inputFocus ? (0, _core.jsx)(_ChevronUp["default"], {
    color: "neutral07",
    fontSize: "small"
  }) : (0, _core.jsx)(_ChevronDown["default"], {
    fontSize: "small"
  });
};

var variantIcon = (_variantIcon = {}, _defineProperty(_variantIcon, _components.VARIANT_TYPES.success, IconSuccess), _defineProperty(_variantIcon, _components.VARIANT_TYPES.warning, IconWarning), _defineProperty(_variantIcon, _components.VARIANT_TYPES.danger, IconError), _defineProperty(_variantIcon, _components.VARIANT_TYPES.loading, IconLoading), _variantIcon);

var InputSelect = function InputSelect(_ref2) {
  var withRef = _ref2.withRef,
      component = _ref2.component,
      className = _ref2.className,
      name = _ref2.name,
      id = _ref2.id,
      dataTestId = _ref2['data-testid'],
      _onBlur = _ref2.onBlur,
      _onChange = _ref2.onChange,
      _onFocus = _ref2.onFocus,
      _onInput = _ref2.onInput,
      type = _ref2.type,
      width = _ref2.width,
      label = _ref2.label,
      value = _ref2.value,
      defaultValue = _ref2.defaultValue,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 'default' : _ref2$size,
      disabled = _ref2.disabled,
      readOnly = _ref2.readOnly,
      loading = _ref2.loading,
      helperText = _ref2.helperText,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? 'default' : _ref2$variant,
      inputBackground = _ref2.inputBackground,
      hideDefaultOption = _ref2.hideDefaultOption,
      options = _ref2.options,
      other = _objectWithoutProperties(_ref2, ["withRef", "component", "className", "name", "id", "data-testid", "onBlur", "onChange", "onFocus", "onInput", "type", "width", "label", "value", "defaultValue", "size", "disabled", "readOnly", "loading", "helperText", "variant", "inputBackground", "hideDefaultOption", "options"]);

  var _ref3 = (0, _react.useState)(!!value),
      _ref4 = _slicedToArray(_ref3, 2),
      labelShrink = _ref4[0],
      setLabelShrink = _ref4[1];

  var _ref5 = (0, _react.useState)(false),
      _ref6 = _slicedToArray(_ref5, 2),
      inputFocus = _ref6[0],
      setInputFocus = _ref6[1];

  var _ref7 = (0, _react.useState)(false),
      _ref8 = _slicedToArray(_ref7, 2),
      inputHover = _ref8[0],
      setInputHover = _ref8[1];

  var hasValue = function hasValue(elementValue) {
    return elementValue && elementValue !== [] && elementValue !== '';
  };

  var toggleHover = function toggleHover() {
    return setInputHover(!inputHover);
  };

  var Icon = variantIcon[variant];
  return (0, _core.jsx)(_FormControl.FormControl, null, (0, _core.jsx)(_components.InputField, (0, _extends2["default"])({
    as: component,
    className: className,
    name: name,
    label: label,
    width: width,
    size: size,
    disabled: disabled,
    readOnly: readOnly,
    inputFocus: inputFocus,
    inputHover: inputHover,
    variant: variant,
    options: options,
    onMouseEnter: function onMouseEnter() {
      return toggleHover();
    },
    onMouseLeave: function onMouseLeave() {
      return toggleHover();
    }
  }, other), (0, _core.jsx)(_InputLabel.InputLabel, {
    labelShrink: labelShrink,
    size: size,
    inputFocus: inputFocus,
    inputHover: inputHover,
    disabled: disabled,
    readOnly: readOnly,
    inputBackground: inputBackground,
    variant: variant
  }, label), (0, _core.jsx)(_InputSelectComponent.InputSelectComponent, {
    ref: withRef,
    name: name,
    id: id,
    "data-testid": dataTestId,
    type: type,
    value: value,
    defaultValue: defaultValue,
    width: width,
    variant: variant,
    disabled: disabled,
    readOnly: readOnly,
    inputFocus: inputFocus,
    inputHover: inputHover,
    hideDefaultOption: hideDefaultOption,
    options: options,
    onFocus: function onFocus(event) {
      var content = event.target.value;

      if (readOnly && !content) {
        setLabelShrink(false);
        setInputFocus(false);
      } else {
        setLabelShrink(true);
        setInputFocus(true);
      }

      _onFocus == null ? void 0 : _onFocus(event);
    },
    onBlur: function onBlur(event) {
      var content = event.target.value;

      if (hasValue(content)) {
        setLabelShrink(true);
        setInputFocus(false);
      } else {
        setLabelShrink(false);
        setInputFocus(false);
      }

      _onBlur == null ? void 0 : _onBlur(event);
    },
    onChange: function onChange(event) {
      _onChange == null ? void 0 : _onChange(event);
    },
    onInput: function onInput(event) {
      _onInput == null ? void 0 : _onInput(event);
    }
  }), !function () {
    return variant === 'default' || disabled || readOnly;
  }() && (0, _core.jsx)(_InputIcon.InputIcon, {
    variant: variant,
    relatedInputType: "select",
    inputFocus: inputFocus,
    readOnly: readOnly
  }, (0, _core.jsx)(Icon, null)), (0, _core.jsx)(_InputIcon.InputIcon, {
    selectIcon: true,
    relatedInputType: "select",
    inputFocus: inputFocus
  }, (0, _core.jsx)(SelectIcon, {
    inputFocus: inputFocus,
    inputHover: inputHover,
    disabled: disabled,
    readOnly: readOnly
  }))), helperText && (0, _core.jsx)(_HelperText.HelperText, {
    text: helperText,
    variant: variant,
    size: size,
    disabled: disabled
  }));
};

process.env.NODE_ENV !== "production" ? InputSelect.propTypes = propTypes : void 0;
process.env.NODE_ENV !== "production" ? SelectIcon.propTypes = selectIconPropTypes : void 0;
var WithForwardRef = (0, _utils.withForwardRef)(InputSelect);
exports.InputSelect = WithForwardRef;